import { render, staticRenderFns } from "./ValidityServices.vue?vue&type=template&id=027be7ee&scoped=true"
import script from "./ValidityServices.vue?vue&type=script&lang=js"
export * from "./ValidityServices.vue?vue&type=script&lang=js"
import style0 from "./ValidityServices.vue?vue&type=style&index=0&id=027be7ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027be7ee",
  null
  
)

export default component.exports